import React from "react";
import { Flex, HorizontalToolbar, useDataTableContext } from "@theorgchartdev/storybook";
import ColumnDisplayMenu from "./ColumnDisplayMenu/ColumnDisplayMenu";
import CompositeTableSearchControls from "../../Blocks/Composites/CompositeChartSearch/CompositeTableSearchControls";
import { useDirectorySearchContext } from "@/providers/DirectorySearchProvider";
import { useDirectoryTabularContext } from "@/providers/DirectoryTabularProvider";
import DirectoryColumnDisplayMenu from "./directory/ColumnDisplayMenu";

export const MainToolbarDirectoryTabular = () => {
  const {
    setResults,
    searchCtrlRef,
    projectFields,
    holderFields,
    updateState,
    queryOptions,
    state
  } = useDirectoryTabularContext();

  const table = useDataTableContext();

  return (
    <HorizontalToolbar
      customToolbarClass="oc-fill-height"
      leftContent={
        <Flex direction="column" gap={12}>
          <Flex gap={12} alignContent="center">
            <CompositeTableSearchControls
              UpdateSearchResultContext={setResults}
              processFullResult
              projectFields={projectFields}
              holderFields={holderFields}
              searchCtrlContext={searchCtrlRef}
              prefixId={"directory-tabular"}
              queryOptions={queryOptions}
              useProjectFieldDefs={true}
              disableRefetchOnSearchFocus
              onSearchLoading={isLoading => {
                updateState({ isSearchLoading: isLoading });
              }}
              hideAdvancedSearch
            />
            <DirectoryColumnDisplayMenu />
          </Flex>
        </Flex>
      }
      size={"large"}
    />
  );
};

const MainToolbarDirectory = () => {
  const { searchCtrl, dirSearchState, setDirSearchState, UpdateSearchResults } =
    useDirectorySearchContext();

  const queryOptions = { mode: "directory" };

  return (
    <HorizontalToolbar
      leftContent={
        <CompositeTableSearchControls
          UpdateSearchResultContext={UpdateSearchResults}
          projectFields={dirSearchState.columnNames}
          searchCtrlContext={searchCtrl}
          prefixId={"directory"}
          queryOptions={queryOptions}
        />
      }
      rightContent={
        <ColumnDisplayMenu
          searchCtrl={searchCtrl}
          searchState={dirSearchState}
          setSearchState={setDirSearchState}
        />
      }
      size={"large"}
    />
  );
};

export default MainToolbarDirectory;
